import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { func, number, string } from 'prop-types';
import React from 'react';
/**
 * This component can be used to load some DOM just before it scrolls into the screen. Currently, it does not support unloading. The `margin` prop is passed to `IntersectionObserver`.
 *
 * Example
 * ```javascript
 * import { WithLazy } from '@quintype/components';
 *
 * <WithLazy margin="50px">{() =>
 *   <SomeHeavyComponent />
 * }</WithLazy>
 * ```
 * @component
 * @hideconstructor
 * @category Other
 */

export var WithLazy = /*#__PURE__*/function (_React$Component) {
  _inherits(WithLazy, _React$Component);

  var _super = /*#__PURE__*/_createSuper(WithLazy);

  function WithLazy(props) {
    var _this;

    _classCallCheck(this, WithLazy);

    _this = _super.call(this, props);
    _this.state = {
      loaded: false
    };
    _this.observerRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(WithLazy, [{
    key: "render",
    value: function render() {
      if (this.state.loaded) {
        return this.props.children();
      } else {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            height: this.props.height || 50
          },
          ref: this.observerRef
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.observer = new global.IntersectionObserver(function (entries, observer) {
        return _this2.observerCallback(entries, observer);
      }, {
        rootMargin: this.props.margin || "160px"
      });
      this.observer.observe(this.observerRef.current);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.observer.disconnect();
    }
  }, {
    key: "observerCallback",
    value: function observerCallback(entries, observer) {
      var _this3 = this;

      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.isIntersecting === undefined) {
          _this3.setState({
            loaded: true
          });

          observer.disconnect();
        }
      });
    }
  }]);

  return WithLazy;
}(React.Component);